/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2024-11-25 12:26:52                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2025-02-24 17:07:08                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
  * Styles
  * dateSelect: date picker component
*/

/* Imports */
import DatePicker from "react-datepicker";
/***/

/* Styles */
import "./DateSelect.scss";
import "react-datepicker/dist/react-datepicker.css";
import { CalendarDateRangeIcon } from "@heroicons/react/24/outline";
/***/

/**
* DateSelect: date picker component
* @param value - current value
* @param onChange - on value change event
* @param className - additional classNames
* @param showTimeSelect - whether to show time select
* @param timeFormat - format for time display (default "HH:mm")
* @param dateFormat - format for date display (default "yyyy/MM/dd")
*/
export default function DateSelect({
  value,
  onChange,
  className = "",
  showTimeSelect = false,
  timeFormat = "HH:mm",
  dateFormat = "yyyy/MM/dd"
}: {
  value?: string,
  onChange?: (date: string) => void,
  className?: string,
  showTimeSelect?: boolean,
  timeFormat?: string,
  dateFormat?: string
}) {
  // Si showTimeSelect est true, ajuster le format pour inclure l'heure
  const effectiveDateFormat = showTimeSelect ? `${dateFormat} ${timeFormat}` : dateFormat;

  // Une valeur que `new Date` ne sait pas lire donne une Invalid Date, que react-datepicker
  // formate en jetant `RangeError: Invalid time value` -- ce qui fait tomber la page entière et
  // non le seul champ. Un champ vide est un bien meilleur échec.
  const parsed = value ? new Date(value) : null;
  const selected = parsed && !Number.isNaN(parsed.getTime()) ? parsed : null;
  
  return (
    <div className={`datepicker ${className}`}>
      <DatePicker 
        placeholderText={showTimeSelect ? "AAAA/MM/JJ HH:mm" : "AAAA/MM/JJ"}
        selected={selected}
        dateFormat={effectiveDateFormat}
        popperClassName="date-picker-reports"
        popperPlacement="bottom-start"
        showIcon
        icon={<CalendarDateRangeIcon/>}
        onChange={(e) => onChange && onChange(e ? (e as Date).toISOString() : "")}
        showTimeSelect={showTimeSelect}
        timeFormat={timeFormat}
        timeIntervals={15}
      />
    </div>
  );
}
/***/
